<div class="relative w-24 h-24">
	<div
		class="absolute inset-0 rounded-[15%] animate-ripple bg-gray-50 animate-delay-0"
	></div>
	<div
		class="absolute inset-0 rounded-[15%] animate-ripple bg-gray-100 animate-delay-1000"
	></div>
	<div
		class="absolute inset-0 rounded-[15%] animate-ripple bg-gray-200 animate-delay-2000"
	></div>

	<img [src]="imagePath()" [alt]="altText()" class="relative z-10 w-24 h-24" />
</div>
